import React from 'react';
import { motion } from 'framer-motion';

const Header = ({ name, jobTitle, location, email }) => {
    return (
        <motion.header
            className="header"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
        >
            <div className="header-top">
                <h1 className="header-name">{name}</h1>
            </div>
            <div className="header-meta">
                <span className="badge">💼 {jobTitle}</span>
                <span>📍 {location}</span>
                {email && <span>✉️ {email}</span>}
            </div>
        </motion.header>
    );
};

export default Header;
